import { useState, useEffect } from "react";
import Auth from "./sdk/Auth";

const LoginDemo = () => {
  const [env, setEnv] = useState("japan");

  useEffect(() => {
  }, []);

  const handleGo = () => {
      Auth.init(env);
      window.location.href = Auth.getEnv().aws_cognito_login;
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px", fontFamily: "Arial, sans-serif" }}>
      <h1>Case Report</h1>
      <div style={{ display: "inline-flex", gap: "10px", alignItems: "center", marginTop: "20px" }}>
        <select
          value={env}
          onChange={(e) => setEnv(e.target.value)}
          style={{ padding: "8px", fontSize: "16px", borderRadius: "4px" }}
        >
          <option value="dev">Dev Report</option>
          <option value="qa">QA Report</option>
          <option value="japan">Japan Prod Report</option>
        </select>
        <button
          onClick={handleGo}
          style={{
            padding: "8px 16px",
            fontSize: "16px",
            borderRadius: "4px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
        >
          Go
        </button>
      </div>
    </div>
  );
};

export default LoginDemo;